import * as React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import SummaryDisclosures from "./SummaryDisclosures";

const styles = (theme) => ({
  disclosureContentWrapper: {
    paddingBottom: 50,
  },
});

const DrawerDisclosures = (props) => {
  const { classes } = props;
  return (
    <div className={classes.disclosureContentWrapper}>
      <SummaryDisclosures />
    </div>
  );
};

export default withStyles(styles)(DrawerDisclosures);



// WEBPACK FOOTER //
// ./src/components/Content/DrawerDisclosures.jsx